<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="180px" class="demo-ruleForm">

      <el-form-item :label="$t('app.sendInterSms.form.iccidList')" prop="msisdns" >
        <template slot="label">
          <el-tooltip :content="$t('app.sendInterSms.tooltip.iccidList')" placement="top">
            <span><i class="el-icon-question" style="color: black;"></i>{{ $t('app.sendInterSms.form.iccidList') }}</span>
          </el-tooltip>
        </template>
        <el-input v-model="ruleForm.msisdns" type="textarea" :placeholder="$t('app.sendInterSms.form.iccidPlaceholder')" rows="6" style="width:460px" ></el-input>
      </el-form-item>

      <el-form-item :label="$t('app.sendInterSms.form.smsContent')" prop="tip">
          <el-input v-model="ruleForm.content" type="textarea" :placeholder="$t('app.sendInterSms.form.smsContentPlaceholder')" autosize style="width:460px"></el-input>
      </el-form-item>

      <el-form-item>
         <el-button type="primary" size="medium" @click="send()" v-hasPermi="['sms:center:sendInter']">{{ $t('app.sendInterSms.button.send') }}</el-button>
      </el-form-item>

    </el-form>

    <div class="cardContent marge-class">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="checkPermi(['sms:center:sentInter'])">
        <el-tab-pane :label="$t('app.sendInterSms.tab.sentRecord')" name="sent">
          <interSentList ref="sentListRef" ></interSentList>
        </el-tab-pane>
        <el-tab-pane :label="$t('app.sendInterSms.tab.replyRecord')" name="received" v-if="checkPermi(['sms:center:receivedInter'])">
          <interReceivedList ref="receivedListRef"></interReceivedList>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import interSentList from "@/components/sendSms/interSentList.vue";
import interReceivedList from "@/components/sendSms/interReceivedList.vue";

import {simInterSendSms,simInterSendBatchSms} from "@/api/international.js";
export default {
  name: "sendInterSms",
  data() {
    let checkMsisdns= (rule,value,callback) => {
      if(!value){
        return callback(new Error(this.$t('app.sendInterSms.validation.iccidRequired')))
      } else {
        let msisdnArr = value.trim().split(/[(\r\n)\r\n]+/);
        if(msisdnArr != null && msisdnArr.length > 2000){
          return callback(new Error(this.$t('app.sendInterSms.validation.iccidExceed')))
        } else {
          return callback()
        }
      }
    }
    return {
      activeName: "sent",
      ruleForm: {
        numberType:1,
        msisdn:"",
        msisdns:"",
        actionid:null,
        content:"",
        oldContent:"",
      },
      smsTemplateOptions:[],
      numberTypeOptions:[
        {value:1,label:"ICCID"}
      ],
      rules: {
        actionid: [
          { required: true, message: this.$t('app.sendInterSms.validation.selectTemplate'), trigger: "blur" }
        ],
        content: [
          { required: true, message: this.$t('app.sendInterSms.validation.enterContent'), trigger: "blur" },
        ],
        msisdns: [
          { required: true, validator:checkMsisdns, trigger: "blur" },
        ],
      },
      inputArr:[],
      params:[]
    };
  },
  components: {
    interSentList,interReceivedList
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    },
  },
  methods: {
    // 发送
    send(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
            let msisdnArr = this.ruleForm.msisdns.trim().split(/[(\r\n)\r\n]+/);
            if(msisdnArr != null && msisdnArr.length == 1){
              this.ruleForm.msisdn = this.ruleForm.msisdns.trim();
              this.sendSms();
            } else if(msisdnArr != null && msisdnArr.length > 1){
              this.sendBatchSms();
            }
        }
      })
    },
    // 发送短信
    sendSms() {
      let data = {
        ...this.ruleForm,
      };
      this.$alert(this.$t('app.sendInterSms.message.confirmContent'), this.$t('app.sendInterSms.message.confirmTitle'), {
        confirmButtonText: this.$t('app.common.confirm')
      }).then(() => {
        simInterSendSms(data).then(res => {
          if (res.data.code == 200) {
            this.$notify({
              title: this.$t('app.common.success'),
              message: this.$t('app.sendInterSms.message.sendSuccess'),
              type: "success"
            });
            this.ruleForm = {};
          } else {
            this.$message.error(res.data.message);
          }
          this.$refs.sentListRef.initData();
        });
      });
    },
    // 群发短信
    sendBatchSms() {
      let data = {
        ...this.ruleForm,
      };
      this.$alert(this.$t('app.sendInterSms.message.confirmContent'), this.$t('app.sendInterSms.message.confirmTitle'), {
        confirmButtonText: this.$t('app.common.confirm')
      }).then(() => {
        simInterSendBatchSms(data).then(res => {
          if (res.data.code == 200) {
            this.ruleForm = {}
            this.$notify.info({
              title: this.$t('app.common.tip'),
              message: this.$t('app.sendInterSms.message.batchTip'),
              duration: 1000,
              offset:30
            });
            setTimeout(()=>{
              this.$router.push(`/taskCenter/missionList`);
            },1000)
          } else {
            this.$message.error(res.data.message);
          }
          this.$refs.sentListRef.initData();
        });
      });
    },
    // 运营商
    transferType(status){
      let obj = {
        '1': this.$t('app.common.chinaTelecom'),
        '2': this.$t('app.common.chinaMobile'),
        '3': this.$t('app.common.chinaUnicom'),
        '4': this.$t('app.common.international'),
      };
      return obj[status];
    },
    
    handleClick(tab) {
      this.$router.push("/smsCenter/sendInterSms?msisdn=" + this.ruleForm.msisdns);
      if (tab.name == "sent") {
        this.$refs.sentListRef.initData();
      }else if(tab.name == "received"){
        this.$refs.receivedListRef.initData();
      }
    },
  },
  created() {

  },
  mounted() {

  }
};
</script>

